import { render, staticRenderFns } from "./zhuanxiangCpn.vue?vue&type=template&id=b296c5d0&scoped=true&"
import script from "./zhuanxiangCpn.vue?vue&type=script&lang=js&"
export * from "./zhuanxiangCpn.vue?vue&type=script&lang=js&"
import style0 from "./zhuanxiangCpn.vue?vue&type=style&index=0&id=b296c5d0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b296c5d0",
  null
  
)

export default component.exports